module.exports = __webpack_public_path__ + "fonts/Muyao.min.009ea542.ttf";